import { useWindowSize } from "helpers/hooks"
import ModalCustom from "."
import { CheckModalProps } from "./ModalDelete"

export interface DeleteModalProps {
  content: React.ReactNode
  label: string
  contentWrapperStyles?: React.CSSProperties
}

const ModalCheck = (props: CheckModalProps) => {
  const {
    content,
    label,
    contentWrapperStyles = {
      paddingBottom: 16,
    },
  } = props

  const { isMobile } = useWindowSize()

  return (
    <ModalCustom
      label={label ?? "Confirmation"}
      styleRoot={{
        width: isMobile ? "-webkit-fill-available" : 400,
        paddingRight: 0,
      }}
      bodyChildren={
        <div className="flex flex-col">
          <div
            className="flex flex-col items-center"
            style={contentWrapperStyles}
          >
            {content}
          </div>
        </div>
      }
    />
  )
}
export default ModalCheck
